import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, useMinimalsTheme } from '@tom-ui/ui'

interface Props {
  isPriority: boolean
}
export const PriorityChip = ({ isPriority }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Box data-cy='priority-chip'>
      {isPriority ? (
        <ColoredLabel
          label={t('high', 'High')}
          color='warning'
          sx={{
            width: 'fit-content',
            backgroundColor: theme.palette.warning.lighter,
          }}
        />
      ) : (
        <>-</>
      )}
    </Box>
  )
}
